/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
async function handleShopifyRegister(event) {
    event.preventDefault();

    const errorElement = document.querySelector('.shopify-register-error-banner.hidden');
    const errorClass = '.shopify-register-error-banner';
    if (!errorElement) {
        hideError(errorClass);
    }

    const firstName = document.getElementById('ShopifyRegisterForm-FirstName').value;
    const lastName = document.getElementById('ShopifyRegisterForm-LastName').value;
    const email = document.getElementById('ShopifyRegisterForm-email').value;
    const phoneNumber = document.getElementById('ShopifyRegisterForm-Phone').value;
    const newsLetterSubscribed = document.getElementById('ShopifyRegisterForm-Newsletter').checked;

    try {
        toggleLoadingBtn('shopify-register');
        const response = await fetch(`${PROXY}/customer/register`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                uuid: sessionStorage.getItem('otp-uuid'),
                firstName,
                lastName,
                phoneNumber,
                email,
                newsLetterSubscribed
            }),
        });

        const jsonShopifyUrl = await response.json();

        if (!response.ok) {
            throw new Error('somethingWrong');
        }

        if (!jsonShopifyUrl.success || !jsonShopifyUrl.redirectUrl) {
            throw new Error('somethingWrong');
        }

        window.location.replace(jsonShopifyUrl.redirectUrl);
    } catch (error) {
        showError(errorClass, 'somethingWrong');
    } finally {
        toggleLoadingBtn('shopify-register');
    }
};
